import { render, staticRenderFns } from "./AccordBlock.vue?vue&type=template&id=62295f58"
import script from "./AccordBlock.vue?vue&type=script&lang=js"
export * from "./AccordBlock.vue?vue&type=script&lang=js"
import style0 from "./AccordBlock.vue?vue&type=style&index=0&id=62295f58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports